<template>
  <el-row v-if="show" id="sidebar-container" type="flex" justify="end" @click.native="close">
    <el-col id="sidebar" :xs="24" :md="12" :lg="8">
      <h3>Lịch sử thay đổi</h3>
      <br/>
      <VersionInfo
        v-for="version in versions"
        :key="version.name"
        :version="version"
        @click="clickVersion(version)"
      />
    </el-col>
  </el-row>
</template>

<script>
import VersionInfo from "@/components/ResultDocument/version/VersionInfo.vue"
export default {
  name: "VersionListSideBar",
  components: { VersionInfo },
  props: {
    versions: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      show: false,
    }
  },
  methods: {
    clickVersion(version) {
      console.log('loooooo')
      this.close()
      this.$emit("click", version)
    },
    open() {
      this.show = true
    },
    close() {
      console.log("AHIHI")
      this.show = false
    },
  },
}
</script>

<style scoped>
#sidebar {
  background-color: white;
  height: 100%;
  padding: 1rem;
}
#sidebar-container {
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  position: absolute;
  background-color: rgba(105, 105, 105, 0.5);
  z-index: 1000000;
}
</style>
